import { cn } from "../utils/cn";

type TextareaProps = {
  label: string;
  placeholder?: string;
  state?: "default" | "hover" | "active" | "focus" | "disabled" | "error";
};

export function Textarea({ label, placeholder, state = "default" }: TextareaProps) {
  const stateClasses =
    state === "hover"
      ? "bg-surface-muted"
      : state === "active"
        ? "bg-border/40"
        : state === "focus"
          ? "outline outline-2 outline-primary/40 outline-offset-2"
          : state === "error"
            ? "border-danger"
          : "";
  const labelClass = state === "error" ? "text-danger" : "text-muted";
  return (
    <label className={cn("grid gap-2 text-sm", labelClass)}>
      {label}
      <textarea
        className={cn(
          "min-h-[96px] rounded-md border border-border bg-surface px-3 py-2 text-text",
          stateClasses,
          state === "disabled" && "opacity-50"
        )}
        disabled={state === "disabled"}
        placeholder={placeholder}
      />
    </label>
  );
}
